export default __webpack_public_path__ + "static/media/congratulations.1e642fa2.png";